const model = {
    data: [],
    loading: false,
    errors: null,
};

export default model;